/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowWithTextCustom = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowWithTextCustom = $.extend(this, window.PXUTheme.getSectionData($section));

    const textTransition = this.text_transition;

    // Selectors
    const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
    const $textSlideshowEl = $section.find('[data-text-slideshow]').removeClass('is-hidden');
    const $imageSlideshowMobileEl = $section.find('[data-image-slideshow-mobile]');

    const $this = this;
    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.imageSlideshow = $imageSlideshowEl;
    this.textSlideshow = $textSlideshowEl;
    this.textPart = $section[0].querySelector(".text-slideshow-column");
    this.slideButtons = $section[0].querySelectorAll(".button_container[data-button-index]");
    this.mobileSliderParent = $section[0].querySelector(".slideshow_mobile-inner");


    this.delegateElement.on('click', '.button_container[data-button-index] button', $this.clickSlideButton.bind(this));

    this.arrow = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" fill=\"none\"><path d=\"M15.4369 10.0001H0.871094V8.00008H15.4369L9.15261 1.70718L10.5649 0.292969L19.26 9.00008L10.5649 17.7072L9.15261 16.293L15.4369 10.0001Z\" fill=\"#313030\"/></svg>";
    
    const $imageSlideshow = $imageSlideshowEl.flickity({
      contain: true,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: false,
      draggable: false,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          $this.handleInitSlideButton();
        }
      }
    });

    const $textSlideshow = $textSlideshowEl.flickity({
      autoplay: false,
      contain: true,
      imagesLoaded: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      lazyload: 4,
      prevNextButtons: false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: false,
      on: {
        ready: function () {
          const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
          window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);
        }
      }
    });

    const $imageSlideshowMobile = $imageSlideshowMobileEl.flickity({
      // pageDots: this.number_of_slides > 1,
      pageDots: false,
      prevNextButtons: false,
      // arrowShape: { 
      //   x0: 10,
      //   x1: 50, y1: 50,
      //   x2: 70, y2: 50,
      //   x3: 30
      // },
      // fade: true,
      wrapAround: true,
      draggable: true,
      on: {
        ready: function() {          
          const $currentTextSlide = $imageSlideshowMobileEl.find('.is-selected');
          var color = $currentTextSlide[0].getAttribute("data-color");
          $this.mobileSliderParent.style.backgroundColor = color;
        }
      }
    });

    $imageSlideshow.on('change.flickity', function (event, index) {
      $textSlideshow.flickity('select', index, true, true);

      const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
      window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);
      $this.handleActiveSlideButton(index);
    });

    $textSlideshow.on('change.flickity', function (event, index) {
      $imageSlideshow.flickity('select', index, true, false);
    });

    $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');

    $imageSlideshowMobile.on('change.flickity', function (event, index) {
      var cell = this.querySelector(".mobile_slide.is-selected");
      var color = cell.getAttribute("data-color");
      $this.mobileSliderParent.style.backgroundColor = color;
    });

  },
  handleInitSlideButton: function() {
    var $activeSlide = this.imageSlideshow.find('.is-selected');          
    var activeIndex = $activeSlide[0].getAttribute("data-slide-index");
    this.handleActiveSlideButton(activeIndex)
  },
  handleActiveSlideButton: function(index) {
    this.slideButtons.forEach(function(el){
      el.classList.remove("selected");
      var arrow = el.querySelector('.button_arrow');
      if (arrow != null) {
        el.removeChild(arrow);
      }
    });
    var button = document.querySelector(".button_container[data-button-index='"+ index +"']");
    button.classList.add("selected");
    var arrow = document.createElement("div");
    arrow.classList.add("button_arrow");
    arrow.innerHTML = this.arrow;
    button.insertBefore(arrow, button.firstChild);
    this.textPart.parentElement.style.backgroundColor = button.getAttribute("data-color");
  },
  clickSlideButton: function(event){
    var button = event.target.closest("[data-button-index]");
    var buttonIndex = button.getAttribute("data-button-index");
    this.imageSlideshow.flickity('select', buttonIndex, true, true);
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderMobile = $section.find('[data-image-slideshow-mobile]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);
    $sliderMobile.flickity('select', $sliderIndex, true, true);

    // Resize flickity when the slider is settled
    $slider.on( 'settle.flickity', function() {
      $slider.flickity('resize');
    }, 500);
    $sliderMobile.on( 'settle.flickity', function() {
      $sliderMobile.flickity('resize');
    }, 500);
    
  },
	unload: function($section) {
    $section.find('.flickity-button').unwrap();
	}
}

/******/ })()
;